<template>
	
	<!-- <div class="container"> -->
		<!-- <div class="col-md-12 mt-40 text-center"> -->
			<div class="split left">
				<div class="centered">
					<router-view />
				</div>
			</div>
			<div class="split right">
					
					<div class="centered">
						<img alt="Twegos logo" width="180" src="@/assets/fitme-logo-gradient.svg">
						<br>
						<div class="p-12 text-left color-white">
							<h2 class="front-page-top-text"> Matching <br>people and companies</h2>
							<h3 class="front-page-bottom-text">sharing the same values </h3>
						</div>
					</div>
			</div>
		<!-- </div> -->
	<!-- </div> -->
</template>

<style lang="scss">
/* Split the screen in half */


@import '/src/bootstrap/css/bootstrap.min.css';
@import '/public/css/app.css';
</style>
<script setup>
import { onUnmounted } from 'vue'

onUnmounted(() => {localStorage.removeItem('user') })
</script>